import getAllFocusableDescendents from '../getAllFocusableDescendents';
import interactiveElementSelector from '../interactiveElementSelector';
import isElementHidden from '../isElementHidden';

var getFirstTabbableDescendent = function getFirstTabbableDescendent(element) {
  var firstFocusableElement = element.querySelector(interactiveElementSelector);

  if (!firstFocusableElement) {
    return null;
  } // searching through all the DOM nodes can get expensive so we attempt to short circuit most of the logic
  // by just checking the first focusable DOM element for visibility, as the else case is somewhat rare


  if (!isElementHidden(firstFocusableElement)) {
    return firstFocusableElement;
  } else {
    var focusableDescendents = getAllFocusableDescendents(element);
    return focusableDescendents.find(function (el) {
      return !isElementHidden(el);
    }) || null;
  }
};

export default getFirstTabbableDescendent;